export const testAttributes = {
    GRID_POST_CONTAINER: 'grid_post_container',
    GRID_POST_SEE_MORE: 'grid_post_see_more'
};

export const defaultAttributes = {
    button_label: 'See More',
    containerId: "related-posts-grid"
}